import { Button, message } from 'antd';
import { observer } from 'mobx-react';
import React, { useState } from 'react';

import type DocumentWithMembershipStore from 'stores/DocumentWithMembershipStore';

export interface RemoveMemberButtonProps {
  memberId: string;
  parentDocument: DocumentWithMembershipStore;
}

function RemoveMemberButton({
  memberId,
  parentDocument,
}: RemoveMemberButtonProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    try {
      await parentDocument.members.removeMember(memberId);
    } catch (error) {
      message.error(
        <span>
          Something went wrong. Please <b>try again</b>...
        </span>
      );
      console.error('Error removing user:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      disabled={!parentDocument.canEdit}
      loading={isLoading}
      onClick={handleClick}
    >
      Remove
    </Button>
  );
}

export default observer(RemoveMemberButton);
